import { Box } from '@mui/material';
import { EMPTY_PLACEHOLDER } from 'shared/constants/layout';

export function EmptyPlaceholder() {
    return (<Box component="span"
        color="text.disabled"
        fontSize="14px"
    >
        { EMPTY_PLACEHOLDER }
    </Box>);
}
